import { ajax } from 'utils';
import { PromiseAction } from '../types/promiseAction';
import { MenuCounts } from '../types/menuCount';
import * as api from 'services/javaApi';

export const GET_MENU_COUNT_CUCCESS =
  'mpc/external/menuCount/get_menu_count_success';

export interface GetMenuCountSuccess {
  type: typeof GET_MENU_COUNT_CUCCESS;
  data?: MenuCounts;
}

export type MenuCountActions = GetMenuCountSuccess;

export type ModuleKey = 'sm' | 'ls' | 'out' | 'bidding';

export const GROUP_MODULE_MAP: Record<string, ModuleKey> = {
  smWorkbench: 'sm',
  lsWorkbench: 'ls',
  outWorkbench: 'out',
  outCompanyManagement: 'out',
  outBidding: 'bidding',
};

export function getMenuCount(moduleKey: ModuleKey = 'out'): PromiseAction {
  let params: any;
  if (moduleKey === 'bidding') {
    params = {
      url: 'outsource/v2/java_proxy/bidding/workbenches/menus_count',
      method: 'POST',
      body: {}
    };
  } else {
    return {
      types: [null, GET_MENU_COUNT_CUCCESS, null],
      promise: () => api.outsourceAccountsMenusCount({
        query_module: moduleKey,
      }),
    };
  }

  return {
    types: [null, GET_MENU_COUNT_CUCCESS, null],
    promise: () =>
      ajax(params),
  };
}
